import { Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";
import InfoCapsule from "../../../common/InfoCapsule";
import { getStatusQuo, postStatusQuo } from "../../../services/yourWishes";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import "./YourWish.scss";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
const YourWish = ({ next, pre }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const navigate = useNavigate();
  const [selectedWishes, setSelectedWishes] = useState([]);
  const [list, setList] = useState([]);
  const [disabledStatusQues, setDisabledStatusQues] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const fetchData = async () => {
    const result = await getStatusQuo(uID);
    if (result.payLoad?.length) {
      setList([...result.payLoad]);
      setSelectedWishes([...result.payLoad]);
      setDisabledStatusQues([
        ...result.payLoad.filter((item) => item?.isStatusQuoChecked),
      ]);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const onClick = (elem) => {
    if (selectedWishes.some((item) => item.statusQuoId === elem.statusQuoId)) {
      setSelectedWishes((pre) =>
        pre.map((item) => {
          if (elem.statusQuoId === item.statusQuoId) {
            return { ...item, isWishChecked: !item.isWishChecked };
          }
          return item;
        })
      );
    } else {
      setSelectedWishes([...selectedWishes, elem]);
    }
  };
  const handleSubmit = async (values = true) => {
    setButtonDisabled(true);
    const result = await postStatusQuo(
      values
        ? [
            ...selectedWishes.map((item) => {
              if (item.isStatusQuoChecked && item.isWishChecked) {
                return {
                  statusQuoId: item.statusQuoId,
                  isStatusQuoChecked: item.isStatusQuoChecked,
                  isWishChecked: true,
                };
              }
              return {
                statusQuoId: item.statusQuoId,
                isStatusQuoChecked: item.isStatusQuoChecked,
                isWishChecked: item.isWishChecked,
              };
            }),
          ]
        : [],
      uID
    );
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    } else {
      toast.error(result?.message);
    }
    setButtonDisabled(false);
  };
  return (
    <Box
      component="div"
      className="your-wishes-container"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="75vh"
    >
      <Box textAlign="center">
        <Typography
          marginTop="0.5rem"
          color="color.magentaDark2"
          variant="h4"
          fontWeight="600"
        >
          {t("sidebar-2-text-2")}
        </Typography>
        <Typography marginTop="0.6rem">{t("your-wish-heading")}</Typography>

        {list.length == 0 ? (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "28px !important",
            }}
          >
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Box
            component="div"
            className="sub-container-1"
            marginTop="28px !important"
          >
            {selectedWishes.map((elem) => {
              return (
                <>
                  {elem?.isDocumentsAllowed && (
                    <InfoCapsule
                      key={elem.statusQuoId}
                      click={() => onClick(elem)}
                      bgColor={
                        elem?.isWishChecked
                          ? "color.magentaLight2"
                          : "color.dimGrey2"
                      }
                      title={t(getKeyFromText(elem.title))}
                      info={t(elem.translationKey)}
                      boxShadow={3}
                      borderRadius="12px"
                      margin="0.8rem 0.3rem"
                      width="260px"
                      padding="0.8rem 0.8rem"
                      // disabled={elem.isStatusQuoChecked}
                      textAlign="right"
                    />
                  )}
                </>
              );
            })}
          </Box>
        )}
      </Box>
      <Box className="submit-btn-conatiner">
        <SecondaryButton
          title={t("back")}
          bgColor="color.transparent"
          borderRadius="14px"
          width="180px"
          marginLeft="20px"
          border="1px solid #dfc8db"
          hoverBgColor="color.transparent"
          click={() => {
            navigate(-1);
          }}
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
        />
        <SecondaryButton
          title={t("save-and-continue")}
          bgColor="#E8D7E5"
          borderRadius="14px"
          width="180px"
          marginLeft="10px"
          border="none"
          hoverBgColor="color.magentaLight1"
          click={handleSubmit}
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
          disabled={buttonDisabled}
        />
        <LinkButton
          title={t("skip-for-now")}
          bgColor="color.transparent"
          borderRadius="14px"
          fontSize="0.8rem"
          width="100px"
          marginLeft="10px"
          padding="0"
          border="none"
          click={() => {
            next();
          }}
          textTransform="initial"
        />
      </Box>
    </Box>
  );
};

export default YourWish;
